<template>
	<div class="c-newsboard--default" data-css="c-newsboard">
		<div class="c-filterable-list--default" data-css="c-filterable-list">
			<div class="grid__container">
				<div class="grid__row">
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>
